import styled from 'styled-components';
import UIBackButton from 'UIComponents/nav/UIBackButton';
import UIToolBar from 'UIComponents/nav/UIToolBar';
import UIToolBarGroup from 'UIComponents/nav/UIToolBarGroup';
import H4 from 'UIComponents/elements/headings/H4';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GRID_BREAKPOINT_SMALL } from 'HubStyleTokens/sizes';
import { RouterLink } from '../../../components/AcademyLinks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UIToolBarGroupNarrow = styled(UIToolBarGroup).withConfig({
  displayName: "AwardShareHeader__UIToolBarGroupNarrow",
  componentId: "sc-1562mn7-0"
})(["flex-grow:0;.inobtrusive-container{position:absolute;}.link{min-width:40px;display:inline-block;padding:12px 0;}@media (max-width:", "){.back-text{display:none;}}"], GRID_BREAKPOINT_SMALL);
const H4Light = styled(H4).withConfig({
  displayName: "AwardShareHeader__H4Light",
  componentId: "sc-1562mn7-1"
})(["font-weight:lighter;margin:8px 0 0 0;"]);
const AwardShareHeader = ({
  backLinkHref
}) => {
  return /*#__PURE__*/_jsxs(UIToolBar, {
    use: "dark",
    children: [/*#__PURE__*/_jsx(UIToolBarGroupNarrow, {
      children: /*#__PURE__*/_jsx(UIBackButton, {
        className: "inobtrusive-container",
        children: /*#__PURE__*/_jsx(RouterLink, {
          className: "link",
          to: backLinkHref,
          use: "on-dark",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            className: "back-text",
            message: "learningCenter.awardShareControls.back"
          })
        })
      })
    }), /*#__PURE__*/_jsx(UIToolBarGroup, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "text-center",
        children: [/*#__PURE__*/_jsx(H4Light, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.trackAwardModal.shareThisCertificate"
          })
        }), /*#__PURE__*/_jsx("small", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.awardShareControls.pleaseAcceptTerms"
          })
        })]
      })
    })]
  });
};
export default AwardShareHeader;